let observer = new IntersectionObserver(
(entries, observer) => { 
entries.forEach(entry => {
    if(entry.isIntersecting){ 
      if (entry.target.alt.includes('videowise-widget')){
        initVideowise();
      }
    }
  });
});

$(document).ready(function () {
$( window ).on( "scroll", function() {   
  document.querySelectorAll('img').forEach(img => { observer.observe(img) });
});
});